import React from 'react';
import AgData from '../assets/AgdataColored.png'
import NDAES from '../assets/ndaes.png'

import { ReactComponent as Twitter } from '../assets/twittericon.svg'
import { ReactComponent as Website } from '../assets/www.svg'
import { ReactComponent as Agresearch } from '../assets/Agresearchicon.svg'
import { ReactComponent as Fb } from "../assets/fbicon.svg";
import { useMediaQuery } from 'react-responsive';




function Footer(){

    const isMobile = useMediaQuery({ query: '(min-width: 250px) and (max-width: 460px)' });

const footerintro = <p className='intro'>Hope you had a great visit at Nexus data flow hub, your gateway to cutting-edge tools and insights for modern farming.</p>

let normalfootertext = <p className='intro'>Hope you had a great visit at Nexus data flow hub, your gateway to cutting-edge tools and insights for modern farming. Whether you're a seasoned agribusiness professional or a budding enthusiast, our platform connects you with a curated selection of apps designed to streamline your data analysis experience</p>

if (isMobile){
    normalfootertext=footerintro
}


    return (<div className='motherfooter'>
        <div className='footerbox'>
            <img className='Aglogo' src={AgData} alt="" />
            {normalfootertext}

            
            <img className='ndaes' src={NDAES} alt="" />
            <div className="divider"></div>
            <div className="roundedcorner"></div>

            

        
            </div>
            <div className="motherfooter2"><div className="curvedbox"></div> <h5 className="footertext"> Connect with Us  </h5>
            <div className="socials"> 
            <a href="https://sites.google.com/ndsu.edu/plsc-bpdm/home" target="_blank" ><Website className="socialbutton"></Website></a>
                <a href="https://www.facebook.com/NorthDakotaAgExperimentStation" target="_blank" ><Fb className='socialbutton'></Fb></a>
                <a href="https://www.facebook.com/NorthDakotaAgExperimentStation" target="_blank"><Twitter className="socialbutton"></Twitter></a>
                <a href="https://www.ndsu.edu/agriculture/ag-research/ag-research" target="_blank"><Agresearch className="socialbutton"></Agresearch></a>
            
                </div></div>
            
            <div className="roundedcorner2"><div className="curvedbox2"></div><div className="curvedbox3"></div></div>
        
        
        </div>
    );
}

export default Footer;